import { appStore } from "../state/store";
import { ProgressBar } from "./ProgressBar";
export class PersonalValues {
    constructor(app) {
        this.app = app;
        this.selectedValues = new Set();
        this.progressBar = new ProgressBar(7, 6);
    }
    updateSliderValue(sliderId, outputId) {
        const slider = document.getElementById(sliderId);
        const output = document.getElementById(outputId);
        if (slider && output) {
            output.textContent = slider.value;
        }
    }
    render() {
        const commonValues = appStore.getState().commonValues;
        const valuesHtml = commonValues.map(value => `
            <button type="button" class="value-button" data-value="${value}">${value}</button>
        `).join('');
        // NEW: HTML for belonging sense sliders
        const belongingSenseHtml = `
            <div class="belonging-sense-section">
                <hr>
                <p>You've defined your values. Now, let's see how they connect to your work environment.</p>
                <div class="form-group slider-group">
                    <label for="alignment-slider">My work feels like a true reflection of my unique talents and character.</label>
                    <div class="slider-wrapper">
                        <span>Disagree</span>
                        <input type="range" id="alignment-slider" name="alignment" min="0" max="100" value="90">
                        <span>Agree</span>
                        <strong id="alignment-output">90</strong>
                    </div>
                </div>
                <div class="form-group slider-group">
                    <label for="confidence-slider">I feel a strong sense of purpose and optimism about the future of my career path.</label>
                    <div class="slider-wrapper">
                        <span>Disagree</span>
                        <input type="range" id="confidence-slider" name="confidence" min="0" max="100" value="95">
                        <span>Agree</span>
                        <strong id="confidence-output">95</strong>
                    </div>
                </div>
            </div>
        `;
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Step 6: Define Your Values & Alignment</h2>
                <p>Select your core professional values. These statements become the lens through which you evaluate your work.</p>
                <form id="values-form">
                    <div class="button-grid">${valuesHtml}</div>
                    ${belongingSenseHtml}
                    <div class="button-container">
                        <button type="submit" class="button-primary">Next</button>
                    </div>
                </form>
            </div>
        `;
    }
    attachEventListeners() {
        const form = document.getElementById('values-form');
        if (!form)
            return;
        // --- 1. Form Submission Handler ---
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            // Gather selected values from the Set
            const selectedValuesArray = Array.from(this.selectedValues).map(value => ({
                id: `value-${value.replace(/\s+/g, '-')}`, // Reconstruct ID for consistency
                name: value
            }));
            // Gather belonging sense data from sliders
            const alignmentInput = document.getElementById('alignment-slider');
            const confidenceInput = document.getElementById('confidence-slider');
            const alignment = alignmentInput ? parseInt(alignmentInput.value, 10) : 0;
            const confidence = confidenceInput ? parseInt(confidenceInput.value, 10) : 0;
            // Call the new combined store action with a single payload
            appStore.updateValuesAndBelonging({
                values: selectedValuesArray,
                belonging: { alignment, confidence }
            });
            // Advance to the next step in the onboarding flow
            this.app.nextStep();
        });
        // --- 2. Value Button Click Handler (Event Delegation) ---
        form.addEventListener('click', (e) => {
            const target = e.target;
            // Check if a value button was clicked
            if (target.classList.contains('value-button')) {
                const value = target.dataset.value;
                if (!value)
                    return;
                const button = target;
                // Toggle selection state in the Set and the UI
                if (this.selectedValues.has(value)) {
                    this.selectedValues.delete(value);
                    button.classList.remove('selected');
                }
                else {
                    this.selectedValues.add(value);
                    button.classList.add('selected');
                }
            }
        });
        // --- 3. Slider Input Event Listeners ---
        const alignmentSlider = document.getElementById('alignment-slider');
        const confidenceSlider = document.getElementById('confidence-slider');
        if (alignmentSlider) {
            alignmentSlider.addEventListener('input', () => {
                this.updateSliderValue('alignment-slider', 'alignment-output');
            });
        }
        if (confidenceSlider) {
            confidenceSlider.addEventListener('input', () => {
                this.updateSliderValue('confidence-slider', 'confidence-output');
            });
        }
    }
}
